module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Exodus-Gods-&-Kings.865c0de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Exodus-Gods-&-Kings.jpg
// module id = xpLT
// module chunks = 0